import { render, staticRenderFns } from "./ValidateSendout.vue?vue&type=template&id=fb875d64&scoped=true&"
import script from "./ValidateSendout.vue?vue&type=script&lang=js&"
export * from "./ValidateSendout.vue?vue&type=script&lang=js&"
import style0 from "./ValidateSendout.vue?vue&type=style&index=0&id=fb875d64&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fb875d64",
  null
  
)

export default component.exports